var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 10.9456C12.2999 10.9456 14.1654 9.08016 14.1654 6.77897C14.1654 4.47778 12.2999 2.6123 9.9987 2.6123C7.69751 2.6123 5.83203 4.47778 5.83203 6.77897C5.83203 9.08016 7.69751 10.9456 9.9987 10.9456Z",
    stroke: "#1C66F6",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 12.6123H14.4614C15.0706 12.6125 15.6588 12.8351 16.1155 13.2384C16.5721 13.6416 16.8658 14.1978 16.9414 14.8023L17.2672 17.4056C17.2965 17.6402 17.2756 17.8782 17.2058 18.1041C17.1361 18.3299 17.0191 18.5383 16.8627 18.7155C16.7063 18.8926 16.5139 19.0345 16.2985 19.1317C16.083 19.2288 15.8494 19.279 15.613 19.279H4.38969C4.15334 19.279 3.91968 19.2288 3.70422 19.1317C3.48877 19.0345 3.29644 18.8926 3.14 18.7155C2.98356 18.5383 2.86659 18.3299 2.79686 18.1041C2.72712 17.8782 2.70621 17.6402 2.73552 17.4056L3.06052 14.8023C3.1361 14.1975 3.43003 13.6411 3.88705 13.2378C4.34406 12.8345 4.93267 12.6121 5.54219 12.6123H5.83469",
    stroke: "#1C66F6",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.3d056af026487935a9efecf0bf180d48.svg";
export { ForwardRef as ReactComponent };